export default __webpack_public_path__ + "static/media/logo-windows.aa3f9d03.svg";